module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_compare_mobile-97fbcf8f6967850cdae31ccadb85647b.jpg";